import React from 'react';

import {
    ChartBarGranph,
    Modulo,
    Right

} from './styles'

type Props = {
    percentModulo: number;
    modulo: number | string;
    total: string;
}

const ChartBarPercent = ({ percentModulo, modulo, total } : Props) => {
    // Garantir formatação consistente
    const formattedModulo = typeof modulo === 'number' 
      ? `Módulo ${modulo}` 
      : modulo;

    return (
        <ChartBarGranph>
            <Modulo percentModulo={percentModulo}>
              <p>{formattedModulo}</p>
            </Modulo>
            <Right><p>{total}</p></Right>
        </ChartBarGranph>
    );
};

export default ChartBarPercent;
